module.exports = new __parcel__URL__("main_theme.99e47374.wav").toString();